const de = {
  'home.eyebrow':         '🌍 geoplay24.com',
  'home.title':           'Geo Play 24',
  'home.subtitle.line1':  '7 immersive Geographie-Spiele.',
  'home.subtitle.line2':  '1 Welt. 5 Stufen. Endloses Staunen.',
  'home.tagline.line1':   'Sieben Spiele, ein Planet.',
  'home.tagline.line2':   'Entdecke jeden Winkel der Erde — wetteifere, sammle Punkte, erobere dein Reich.',
  'home.footer.company':  'Unternehmen',
  'home.footer.legal':    'Rechtliches',
  'home.footer.about':    'Über uns',
  'home.footer.contact':  'Kontakt',
  'home.footer.github':   'GitHub',
  'home.footer.tiktok':   'TikTok',
  'home.footer.x':        'X / Twitter',
  'home.footer.privacy':  'Datenschutz',
  'home.footer.terms':    'Nutzungsbedingungen',
  'home.footer.cookies':  'Cookies',
  'home.copy':            'powered by: © 2026 Janek @ DevFlow C ™️',
  'home.beta.title':      'Werde früher Tester unserer Android-App',
  'home.beta.text':       'Hol dir ein Founder-Badge, lifetime Premium und eine Chance auf die oben gelisteten Verlosungspreise.',
  'home.beta.cta':        'BETA-Programm',

  'common.start':         'Starten',
  'common.startBig':      '▶ Starten',
  'common.back':          'Zurück',
  'common.home':          'Start',
  'common.howToPlay':     'Spielanleitung',
  'common.gotIt':         'Verstanden — zurück zum Spiel',
  'common.next':          'Weiter',
  'common.restart':       'Neu starten',
  'common.tryAgain':      'Erneut versuchen',
  'common.playAgain':     'Nochmal spielen',
  'common.mainMenu':      'Hauptmenü',
  'common.quit':          'Beenden',
  'common.play':          'Spielen',
  'common.unlock':        '🔒 Mit Premium freischalten',
  'common.language':      'Sprache',

  'rules.kicker.goal':         'Ziel',
  'rules.kicker.howToPlay':    'Spielablauf',
  'rules.kicker.levels':       'Stufen',
  'rules.kicker.tips':         'Tipps',
  'rules.gameNotFound':        'Spiel nicht gefunden',
  'rules.points':              'Pkt',

  'games.origin.title':       'Origin Hunt',
  'games.origin.tagline':     'Finde deine Wurzeln',
  'games.origin.description': 'Ein zufälliger Street-View-Ort irgendwo auf der Welt. Finde den Punkt auf der Karte. 100 km → 1 km Genauigkeit über 5 Stufen.',
  'games.hunt.title':         'Object Hunt',
  'games.hunt.tagline':       'GPS-Schatzsuche',
  'games.hunt.description':   'Du landest in der Nähe eines echten Wahrzeichens. Laufe durch Street View, um es zu finden. Der Kompass wird mit jeder Stufe nutzloser.',
  'games.photo.title':        'Photo Detective',
  'games.photo.tagline':      'Lies die Spuren',
  'games.photo.description':  'Ein einzelnes Street-View-Bild — kein Schwenken, keine Bewegung. Lies Schilder, Pflanzen, Sonnenstand. Von 30 Sek bis zu 5 Sek Aufblitzen.',
  'games.pangaea.title':      'Pangaea Puzzle',
  'games.pangaea.tagline':    'Setze die Erde zusammen',
  'games.pangaea.description':'Kontinente und Inseln treiben um einen 3D-Globus. Schiebe sie zurück an ihren Platz — heutige Position oder das alte Pangaea.',

  'rules.origin.goal': 'Du wirst an einen zufälligen Street-View-Ort auf der Erde gesetzt. Stecke dich auf der Weltkarte so genau wie möglich.',
  'rules.origin.step1': 'Schau dich im Panorama um. Lies Schilder, zähle Fahrspuren, beobachte den Sonnenstand.',
  'rules.origin.step2': 'Klicke auf die Mini-Karte, um eine Markierung zu setzen.',
  'rules.origin.step3': 'Bestätige. Je näher dein Pin am echten Ort, desto mehr Punkte.',
  'rules.origin.step4': 'Stufen verketten — schaffe die Distanzschwelle, um die nächste freizuschalten.',
  'rules.origin.level1': 'innerhalb 100 km',
  'rules.origin.level2': 'innerhalb 50 km',
  'rules.origin.level3': 'innerhalb 25 km',
  'rules.origin.level4': 'innerhalb 10 km',
  'rules.origin.level5': 'innerhalb 1 km',
  'rules.origin.tip1': 'Verkehrsseite, Kennzeichenformat und Markierungsfarben verraten das Land schnell.',
  'rules.origin.tip2': 'Vegetation + Sonnenhöhe grenzen den Breitengrad ein. Straßenschilder fixieren die Stadt.',
  'rules.origin.tip3': 'Master Geographer (L5 = 1 km) ist brutal — die meisten Läufe enden auf L3 oder L4.',

  'rules.hunt.goal': 'Du wirst in Street View nahe einem echten Wahrzeichen platziert. Laufe durch das Panorama, bis du darauf stehst. Der Kompass hilft auf höheren Stufen weniger.',
  'rules.hunt.step1': 'Lies den Zielnamen in der oberen Leiste.',
  'rules.hunt.step2': 'Nutze Kompasspfeil + Distanzanzeige zum Anpeilen.',
  'rules.hunt.step3': 'Klicke auf die Pfeile, um durch Street View zu laufen.',
  'rules.hunt.step4': 'Innerhalb der Fundzone wird der „Gefunden"-Knopf aktiv — drücke ihn zum Punkten.',
  'rules.hunt.level1': '5 km entfernt · 10 Min · weltberühmt · Pfeil + exakte Distanz · 100 m Fundzone',
  'rules.hunt.level2': '15 km · 12 Min · weltberühmt · Pfeil + gerundete Distanz',
  'rules.hunt.level3': '25 km · 12 Min · landesbekannt · nur Kompass, keine Distanz',
  'rules.hunt.level4': '50 km · 15 Min · landesbekannt · heiß/kalt-Hinweis',
  'rules.hunt.level5': '50 km · 10 Min · obskur · nur POI-Name, kein GPS',
  'rules.hunt.tip1': 'Auf L4–L5 hast du 3 Compass Pings — Pfeil-Blitze, sparsam einsetzen.',
  'rules.hunt.tip2': 'Halbweg-Bonus: bei der Hälfte gibt es +2 Minuten.',
  'rules.hunt.tip3': 'Wenn du nur den Namen hast, suche im Gedächtnis oder beachte die Umgebung — viele Wahrzeichen sind aus der Ferne erkennbar.',

  'rules.photo.goal': 'Du siehst ein statisches Street-View-Bild — kein Schwenken, keine Bewegung. Aus Schildern, Pflanzen, Sonnenstand und Markierungen leitest du den Ort her.',
  'rules.photo.step1': 'Wähle zuerst eine Region (Welt, Europa, Asien usw.) — das setzt den Heuhaufen.',
  'rules.photo.step2': 'Ein Foto blitzt für eine feste Beobachtungszeit auf. Nutze jede Sekunde.',
  'rules.photo.step3': 'Nach dem Timer erscheint eine Karte. Setze deinen besten Tipp.',
  'rules.photo.step4': 'Näher = mehr Punkte. Das Ergebnis spielt das Foto erneut, damit du siehst, was du übersehen hast.',
  'rules.photo.level1': '30 Sek Beobachtung · 1 000 km Genauigkeit',
  'rules.photo.level2': '20 Sek · 500 km',
  'rules.photo.level3': '15 Sek · 250 km',
  'rules.photo.level4': '10 Sek · 100 km',
  'rules.photo.level5': '5 Sek Aufblitzen · 50 km',
  'rules.photo.tip1': 'Sprache auf Schildern ist die schnellste Spur. Schon ein Wort bestimmt oft das Land.',
  'rules.photo.tip2': 'Sonnenrichtung zeigt Süden (Nordhalbkugel) bzw. Norden (Südhalbkugel).',
  'rules.photo.tip3': 'Strommastenform, Markierungen und Kennzeichen sind erstaunlich aussagekräftig.',

  'rules.pangaea.goal': 'Eine 3D-Erde, sechs Kontinente. Platziere jeden innerhalb der Winkeltoleranz der Stufe — heutige Position oder vor 300 Millionen Jahren in Pangaea.',
  'rules.pangaea.step1': 'Wähle einen Kontinent aus der rechten Liste.',
  'rules.pangaea.step2': 'Klicke auf den Globus, wo er gehört.',
  'rules.pangaea.step3': 'Innerhalb der Toleranz → rastet ein. Sonst → rotes Feedback, neuer Versuch.',
  'rules.pangaea.step4': '3 Versuche pro Kontinent. Mindestens 5 von 6 zum Aufstieg.',
  'rules.pangaea.level1': 'Kontinente · heute · 25° Toleranz',
  'rules.pangaea.level2': 'heute · 18° Toleranz',
  'rules.pangaea.level3': 'heute · 12° punktgenau',
  'rules.pangaea.level4': 'Pangaea · alt · 25° Toleranz',
  'rules.pangaea.level5': 'Pangaea · alt · 18° punktgenau',
  'rules.pangaea.tip1': 'Globus ziehen zum Drehen. Scrollen zum Zoomen.',
  'rules.pangaea.tip2': 'Auf Pangaea-Stufen waren die Kontinente in der Südhalbkugel zusammengeballt — Afrika und Südamerika passen aneinander, Indien lag an Ostafrika, Nordamerika an Europa.',
  'rules.pangaea.tip3': 'Die Antarktis lag etwa am Äquator. Australien klebte unten dran.',

  /* ─── Landmark Quiz ─── */
  'games.landmark.title':          'Landmark Quiz',
  'games.landmark.tagline':        'Erkenne das Wahrzeichen',
  'games.landmark.description':    'Foto eines berühmten Gebäudes oder Denkmals — erkenne es und stecke einen Pin auf die Weltkarte.',
  'rules.landmark.goal':           'Du siehst ein Foto eines bekannten Wahrzeichens. Stecke einen Pin auf die Weltkarte, wo es deiner Meinung nach steht.',
  'rules.landmark.step1':          'Schau das Foto ein paar Sekunden an. Erkenne das Gebäude, beachte den Kontext.',
  'rules.landmark.step2':          'Wenn der Timer endet, erscheint die Weltkarte.',
  'rules.landmark.step3':          'Setze einen Pin und bestätige. Je näher, desto mehr Punkte.',
  'rules.landmark.step4':          'Fünf Stufen. Jede kürzer und enger als die vorherige.',
  'rules.landmark.level1':         '30 Sek zum Schauen · 1 000 km Genauigkeit',
  'rules.landmark.level2':         '20 Sek · 500 km',
  'rules.landmark.level3':         '15 Sek · 250 km',
  'rules.landmark.level4':         '10 Sek · 100 km',
  'rules.landmark.level5':         '5 Sek Aufblitzen · 50 km',
  'rules.landmark.tip1':           'Markante Formen (Eiffel, Pyramiden) sind sofort erkennbar — die Punkte kommen vom präzisen Pinnen.',
  'rules.landmark.tip2':           'Weniger bekannte Wahrzeichen: lies den Kontext — Klima, Baustil, Umgebung.',
  'rules.landmark.tip3':           'Fotos von Wikipedia unter CC-BY-SA. Tippe auf den Credit-Chip für die Quelle.',

  'paywall.title':        "Dieses Spiel ist Premium",
  'paywall.text':         "Schalte dieses Spiel mit Punkten frei, die du beim Spielen sammelst.",
  'paywall.cta':          "BETA-Programm beitreten",
  'paywall.dismiss':      "Vielleicht später",

  /* ─── Spot the Landmark ─── */
  'games.spot.title':       "Spot the Landmark",
  'games.spot.tagline':     "Multiple Choice",
  'games.spot.description': "Foto eines berühmten Gebäudes oder Denkmals — wähle die richtige Antwort aus 3–6 Optionen. Endlos-Modus, jede Runde härter.",

  'rules.spot.goal':   "Schau dir das Foto an, wähle das richtige Wahrzeichen. Ein Fehler beendet den Run.",
  'rules.spot.step1':  "Wähle eine Region (Welt, Europa, Asien…) — der Pool wird auf den Kontinent gefiltert.",
  'rules.spot.step2':  "Ein berühmtes Wahrzeichen-Foto erscheint mit einer Frage.",
  'rules.spot.step3':  "Tippe die richtige Antwort an.",
  'rules.spot.step4':  "Halte die Serie am Leben — jede Stufe fügt eine Option hinzu (max. 6) und wird schwieriger.",
  'rules.spot.level1': "L1–L3 · 3–5 Optionen · nur der Name",
  'rules.spot.level2': "L4+ · 6 Optionen · nur der Name",
  'rules.spot.level3': "L10+ · 6 Optionen · Name + Land",
  'rules.spot.level4': "L20+ · 6 Optionen · Name + Stadt + Land",
  'rules.spot.level5': "Endlos · Punkte skalieren mit Tiefe · ein Fehler beendet alles",
  'rules.spot.tip1':   "Falsche Antworten kommen vom selben Kontinent — genau lesen.",
  'rules.spot.tip2':   "Ikonische Formen (Eiffel, Pyramiden) sind leicht — Punkte gibt's für Tiefe.",
  'rules.spot.tip3':   "Ab L10 kommt das Land dazu; ab L20 die Stadt.",

  "spot.region.title": "Wo möchtest du spielen?",
  "spot.region.sub": "Wähle eine Region. Berühmte Wahrzeichen erscheinen — wähle die richtige Antwort.",
  "spot.q.name": "Was ist dieses Wahrzeichen?",
  "spot.q.namecountry": "Name + Land?",
  "spot.q.namecity": "Name + Stadt + Land?",
  "spot.score": "Punkte",
  "spot.choices": "Optionen",
  "spot.correct": "RICHTIG",
  "spot.wrong": "FALSCH",
  "spot.points": "PUNKTE",
  "spot.runTotal": "Run gesamt",
  "spot.next": "Weiter →",
  "spot.youPicked": "Du hast gewählt",
  "spot.finalScore": "ENDPUNKTZAHL",
  "spot.reachedLevel": "Du hast Level erreicht",
  "spot.tryAgain": "Nochmal ↺",
  "spot.changeRegion": "Region wechseln",
  "spot.mainMenu": "Hauptmenü",

  /* ─── Auth ─── */
  "auth.signIn": "Anmelden",
  "auth.eyebrow": "MINDFUL ZEN WORLD",
  "auth.title": "Anmelden oder Konto erstellen",
  "auth.subtitle": "Kein Passwort — wir mailen dir einen Magic Link. Neu hier? Konto wird automatisch angelegt.",
  "auth.send": "Magic Link senden",
  "auth.sending": "Sende…",
  "auth.invalidEmail": "Bitte gültige E-Mail eingeben.",
  "auth.sendFailed": "Link konnte nicht gesendet werden. Versuche es erneut.",
  "auth.checkInbox": "Prüfe dein Postfach",
  "auth.linkSentTo": "Ein Anmeldelink ist unterwegs an",
  "auth.spamHint": "Nicht gefunden? Schau in den Spam-Ordner. Der Link läuft in 1 Stunde ab.",
  "auth.gotIt": "Verstanden",
  "auth.fineprint": "Mit dem Fortfahren akzeptierst du unsere AGB und Datenschutzerklärung.",
  "auth.menu.profile": "Mein Profil",
  "auth.menu.admin": "Admin",
  "auth.menu.signOut": "Abmelden",
  "auth.callback.signingIn": "Du wirst angemeldet…",
  "auth.callback.hold": "Einen Moment.",
  "auth.callback.welcome": "Willkommen",
  "auth.callback.redirecting": "Bringe dich zu den Spielen…",
  "auth.callback.problem": "Etwas ist schiefgelaufen",

  /* ─── Auth ─── */

  /* ─── Profile ─── */
  "profile.title": "Mein Profil",
  "profile.totalPoints": "Gesamtpunkte",
  "profile.totalRuns": "Gespielte Runden",
  "profile.gamesPlayed": "Gespielte Spiele",
  "profile.editTitle": "Profil bearbeiten",
  "profile.displayName": "Anzeigename",
  "profile.avatar": "Avatar",
  "profile.country": "Land (optional)",
  "profile.countryHint": "Zweistelliger ISO-Code, z.B. DE, US, JP. Für Bestenlisten-Flaggen.",
  "profile.save": "Speichern",
  "profile.saving": "Speichere…",
  "profile.saved": "Gespeichert",
  "profile.nameTooShort": "Anzeigename muss mind. 2 Zeichen lang sein.",
  "profile.perGame": "Beste pro Spiel",
  "profile.noRuns": "Noch keine Spiele gespielt — zurück ins Menü und eines auswählen.",

  /* ─── Profile ─── */

  /* ─── Gating + Anon limit ─── */
  "common.locked": "GESPERRT",
  "common.needPoints": "{n} PKT NÖTIG",
  "locked.pill": "GESPERRT",
  "locked.title": "{game} ist gesperrt",
  "locked.text": "Dir fehlen noch {remaining} Punkte um {game} freizuschalten. Spiel die verfügbaren Spiele — jeder Run zählt.",
  "locked.dismiss": "Verstanden",
  "spot.anon.playsLeft": "Noch {n} freie Spiele — anmelden um weiterzumachen.",
  "spot.anon.title": "Deine freien Spiele sind aufgebraucht",
  "spot.anon.text": "Du hast {used} von {limit} freien Spielen genutzt. Melde dich an um weiterzumachen — kostenlos, kein Passwort, nur ein Magic Link per Mail.",
  "spot.anon.signIn": "Anmelden →",
  "spot.anon.back": "Zurück zum Menü",

  /* ─── Gating + Anon limit ─── */

  /* ─── Next game banner ─── */
  "rules.next.upcoming": "ALS NÄCHSTES",
  "rules.next.unlocked": "NÄCHSTES — FREIGESCHALTET",
  "rules.next.unlockedHint": "Du hast genug Punkte — zurück zum Menü und losspielen.",
  "rules.next.needMore": "{remaining} Pkt zum Freischalten — spiel weiter um mehr zu sammeln.",
  "rules.next.signedOut": "Sammle {threshold} Punkte zum Freischalten — melde dich an um sie zu zählen.",
  "rules.next.premiumHint": "Mit Premium freigeschaltet — kommt mit der Android-Beta.",

  /* ─── Next game banner ─── */

  /* ─── Audio Atlas ─── */
  'games.audio.title':       "Audio Atlas",
  'games.audio.tagline':     "Flagge + Hymne",
  'games.audio.description': "Eine Nationalhymne spielt, dazu die Flagge des Landes. Setze einen Pin auf die Hauptstadt.",

  'rules.audio.goal':   "Du hörst eine Nationalhymne und siehst die Flagge. Setze einen Pin auf die Hauptstadt — so genau wie möglich.",
  'rules.audio.step1':  "Wähle eine Region. Der Pool wird auf den Kontinent gefiltert.",
  'rules.audio.step2':  "Die Hymne startet automatisch. Die Flagge bleibt sichtbar.",
  'rules.audio.step3':  "Bei Timer = 0 erscheint die Karte. Setze einen Pin auf die Hauptstadt.",
  'rules.audio.step4':  "Bestehen = innerhalb der Distanzgrenze. Höher = kürzere Hörzeit.",
  'rules.audio.level1': "10 Sek hören · innerhalb 1 000 km",
  'rules.audio.level2': "8 Sek · 500 km",
  'rules.audio.level3': "6 Sek · 250 km",
  'rules.audio.level4': "4 Sek · 100 km",
  'rules.audio.level5': "3 Sek Blitz · 50 km",
  'rules.audio.tip1':   "Die Flagge zu erkennen ist leicht — die Hauptstadt genau zu treffen die echte Prüfung.",
  'rules.audio.tip2':   "Manche Hauptstädte sind nicht die größte Stadt (Brasília, Canberra, Ottawa, Pretoria) — aufpassen.",
  'rules.audio.tip3':   "Tempo und Instrumente der Hymne helfen, wenn die Flagge unbekannt ist.",

  "audio.region.title": "Wo möchtest du hören?",
  "audio.region.sub": "Wähle eine Region. Du hörst eine Nationalhymne und siehst die Flagge — setze einen Pin auf die Hauptstadt.",
  "audio.empty.title": "Noch keine Audio-Clips",
  "audio.empty.text": "Noch keine Hymnen verfügbar — wir kuratieren den Pool. Schau bald wieder vorbei für neue Länder zum Identifizieren.",
  "audio.listen.hint": "Erkennst du Flagge und Hymne? Setze den Pin auf die Hauptstadt.",
  "audio.listen.skip": "Ich weiß genug →",
  "audio.submit.ready": "Tipp abgeben →",
  "audio.submit.empty": "Klicke auf die Karte um einen Pin zu setzen",
  "audio.changeRegion": "Region wechseln",

  /* ─── Empire ─── */
  "profile.empire.title": "Mein Reich",
  "profile.empire.empty": "Identifiziere ein Land im Audio Atlas oder Landmark Quiz um es zu beanspruchen. Dein Reich wächst mit jeder richtigen Antwort.",

  /* ─── Empire ─── */

  /* ─── Boost / Shop ─── */
  "boost.title": "Überspring den Grind",
  "boost.tagline": "Punkte kaufen, schneller freischalten",
  "boost.description": "Keine Lust zu warten? Drei Pakete ab €2.99. Punkte landen sofort auf deinem Konto und zählen für jede Freischaltung.",
  "boost.cta": "Punkte kaufen",
  "shop.title": "Punkte-Shop",
  "shop.sub": "Überspring den Grind",
  "shop.buy": "Kaufen",
  "shop.opening": "Öffne…",
  "shop.success": "Zahlung bestätigt — Punkte sind in Sekunden gutgeschrieben.",
  "shop.cancel": "Checkout abgebrochen — keine Belastung.",
  "shop.fineprint": "Einmalige Zahlung über Stripe. Punkte werden nach Zahlungsbestätigung sofort gutgeschrieben. Kein Abo, keine Verlängerung.",
  "shop.boost.badge": "Beliebt",
  "shop.power.badge": "Bester Wert",

  /* ─── Boost / Shop ─── */
};

export default de;
